var map = {
	"./1_1_1.jpg": "ae46",
	"./2_1_1.jpg": "824c",
	"./2_1_2.jpg": "1bf2",
	"./3_1_1.jpg": "a0899",
	"./3_1_2.jpg": "6ad4",
	"./3_1_3.jpg": "4ec8",
	"./3_1_4.jpg": "160d",
	"./3_1_5.jpg": "e060",
	"./3_1_6.jpg": "051c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "42ba";